import { __extends } from "tslib";
import { deserializeAws_json1_1LookupDeveloperIdentityCommand, serializeAws_json1_1LookupDeveloperIdentityCommand } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { getAwsAuthPlugin } from "@aws-sdk/middleware-signing";
import { Command as $Command } from "@aws-sdk/smithy-client";
var LookupDeveloperIdentityCommand = /** @class */ (function (_super) {
    __extends(LookupDeveloperIdentityCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function LookupDeveloperIdentityCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    LookupDeveloperIdentityCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(getAwsAuthPlugin(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var handlerExecutionContext = {
            logger: {}
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    LookupDeveloperIdentityCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1LookupDeveloperIdentityCommand(input, context);
    };
    LookupDeveloperIdentityCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1LookupDeveloperIdentityCommand(output, context);
    };
    return LookupDeveloperIdentityCommand;
}($Command));
export { LookupDeveloperIdentityCommand };
//# sourceMappingURL=LookupDeveloperIdentityCommand.js.map